export default __webpack_public_path__ + "static/date-label-dont-3-dark-b1e421dd1a6992182ab62f0277bddb93.png";